<template>
  <!-- 推广管理 -->
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-gropu">
          用户昵称
          <el-input class="search-child" v-model="nickname" placeholder="请输入用户昵称"></el-input>
        </div>
        <div class="search-gropu">
          状态
          <el-select class="search-child" v-model="status" placeholder="请选择状态" clearable>
            <el-option v-for="(item,index) in status_list" :key="index" :label="item.label" :value="item.value">{{item.label}}</el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
      </div>
    </div>
    <!--  -->
    <div class="el-card  pd20 content">
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="用户头像/昵称">
          <template slot-scope="scope">
            <div class="userinfo">
              <img :src="scope.row.headimgurl" alt="">
              <el-popover trigger="hover" placement="top">
                {{scope.row.nickname}}
                <div slot="reference" class="name-wrapper">
                  <span class="text-ellipsis">{{scope.row.nickname}}</span>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号"> </el-table-column>
        <el-table-column prop="order_count" label="累计推广订单( 笔 )"> </el-table-column>
        <el-table-column prop="price_sum" label="累计推广金额"> </el-table-column>
        <el-table-column prop="role" label="申请推广员等级"></el-table-column>
        <el-table-column prop="ctime" label="申请时间" width="180"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="status==''">
              <el-button type="success" icon="el-icon-check" circle size="mini" @click="view(1, scope.row)" circle></el-button>
              <el-button type="danger" size="mini" icon="el-icon-close" circle @click="view(2, scope.row)" circle></el-button>
            </div>
            <div v-else>{{status==1?'已通过':'已拒绝'}}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  applyList,
  setApplyStatus
} from "@/api/operating";
export default {
  data() {
      return {
        pages: {},
        list: [],
        nickname: '',
        buy_time: [],
        obj: {},
        status: '',
        status_list: [{
          label: '申请中',
          value: 0
        }, {
          label: '已通过',
          value: 1
        }, {
          label: '已拒绝',
          value: 2
        }],
      }
    },
    methods: {
      // 操作
      view(status, row) {
        let status_text = status == 1 ? '通过' : '拒绝';
        this.$confirm(`确认要${status_text}吗？`, '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {

          setApplyStatus({
            apply_id: row.id,
            status: status
          }).then((data) => {
            if (data.error > 0) {
              this.$message(data.msg);
              return
            }
            this.$message({
              message: status == 1 ? '已通过' : '已拒绝',
              type: 'success'
            });
            this.pullData();
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        });
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.nickname) {
          this.obj['nickname'] = this.nickname;
        }
        if (this.status) {
          this.obj['status'] = this.status;
        }

        applyList(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.headimgurl {
  width: 100px;
  height: 100px;
}

.box {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
}

.userinfo {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
  span {
    width: 44px;
    display: block;
  }
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-child {
  margin-left: 20px;
  width: 150px;
}

.box {
  width: 650px;
}
</style>
